import {baseUrl} from './util'

const config = {
  STATIC_URL: process.env.STATIC_URL,
  MIRADOR_URL: process.env.MIRADOR_URL,
  API_URL: process.env.API_URL
}

console.log(config)

export default config
